import { type PropsWithChildren, useEffect } from 'react';

import { QueryErrorResetBoundary, useQueryErrorResetBoundary } from '@tanstack/react-query';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { useRouter } from '@tanstack/react-router';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary } from 'react-error-boundary';

import { Button } from '@/_components/third_party';

export function ErrorBoundaryWithRetry({ children }: PropsWithChildren<unknown>) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary fallbackRender={OnError} onReset={reset}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}

export function OnError({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <section className="flex w-full flex-col items-center justify-center gap-4">
      <div>There was an error! </div>
      <Button onClick={() => resetErrorBoundary()}>Try again</Button>
      <pre>{(error as Error).message}</pre>
    </section>
  );
}

export const MainErrorBoundary = ({ reset, error }: ErrorComponentProps) => {
  const router = useRouter();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();

  useEffect(() => {
    queryErrorResetBoundary.reset();
  }, [queryErrorResetBoundary]);

  console.log(error);

  return (
    <section className="mt-32 flex w-full flex-col items-center justify-center gap-4">
      <div className="text-foreground text-5xl">:(</div>
      <div className="text-accent-foreground mb-4">
        {error instanceof Error ? error.message : 'An unexpected error occurred.'}
      </div>
      <Button
        onClick={() => {
          reset();
          router.invalidate();
        }}
      >
        Try again
      </Button>
    </section>
  );
};
